import { useEffect, useRef, useState } from "react";
import { LoggedUser, selectLoggedUser, setLoggedUser, setOpneLoginModal } from "../../redux/slices/auth";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCartCount } from "../../redux/slices/cart";
import { useUser } from "../../contexts/userContext";
import { clearGeoInfo } from "../../redux/slices/pincode";
import { setUtmId } from "../../redux/slices/utm";
import { profileClickedEvent } from "../../shared/events/additional.event";


const Profile = ({ user }: { user: LoggedUser }) => {
  const dispatch = useDispatch()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserAuthorized } = useUser()


  const userName = user.profileComplete ? user.name : 'Guest';

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    profileClickedEvent(location.pathname);
    navigate('/profile',);
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const handleCouponClick = () => {
    setIsDropdownOpen(false);
    navigate('/my-coupons',);
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const handleLogoutClick = () => {
    sessionStorage.clear()
    setUserAuthorized(false)
    dispatch(setLoggedUser(false))
    dispatch(setCartCount(0))
    dispatch(setUtmId(null))
    dispatch(clearGeoInfo())
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' })

  };

  return (

    <div className="user-name-container" onClick={() => setIsDropdownOpen((prev) => !prev)}>
      <span className="user-names">
        {userName.charAt(0).toUpperCase()}
      </span>
      {isDropdownOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-item" onClick={handleProfileClick}>
            Profile
          </div>
          <div className="dropdown-item" onClick={handleCouponClick}>
            My Coupons
          </div>
          <div className="dropdown-item" onClick={handleLogoutClick}>
            Sign Out
          </div>
        </div>
      )}
    </div>

  )
}


const LoginButton = () => {
  // {state:{utmQuery:globalUtmQueryRef.current}}
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLoginClick = () => {
    // navigate('/login',) //send utm query here
    dispatch(setOpneLoginModal(true))
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
    ;
  return (
    <button className="sign-in-btn btn btn-success login_btn" onClick={handleLoginClick}>
      Login
    </button>
  )
}



export const LoginInitialsButton = () => {

  const { isAuthorized } = useUser();

  const loggedUser = useSelector(selectLoggedUser)

  return (
    <>{
      loggedUser.userId
        ? (<Profile user={loggedUser} />)
        : (<LoginButton />)
    }

    </>
  );
};
